import DefinitionList from '../DefinitionList/DefinitionList'
import classes from './FileInfo.module.scss'
import { FiFileText } from 'react-icons/fi'

export interface Props {
  name: string
  size: number
  rows: number

}

const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes'

  const kilo = 1000

  const dm = 0
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const index = Math.floor(Math.log(bytes) / Math.log(kilo))

  return parseFloat((bytes / Math.pow(kilo, index)).toFixed(dm)) + ' ' + sizes[index]
}

const FileInfo = ({
  name,
  size,
  rows
}: Props) =>
  <div className={classes.Root}>
    <div className={classes.title}>
      <FiFileText size={18} />
      File info
    </div>
    <DefinitionList variant='beside'>
      {{
        Name: name,
        Size: formatFileSize(size),
        Rows: rows.toLocaleString()
      }}
    </DefinitionList>
  </div>

export default FileInfo
